import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { useScrollContext } from '../contexts/ScrollContext.jsx';
import { BOT } from '../utils/constants';

import { Message } from './Message.jsx';
import { IntroMessage } from './IntroMessage.jsx';

export const MessageList = ({
  conversation,
  setBotIsTyping,
  botIsTyping,
  embed = false,
  sendMessage,
  isFetched,
}) => {
  const { chatBoxRef } = useScrollContext();

  useEffect(() => {
    const divElement = chatBoxRef.current;

    const resizeObserver = new ResizeObserver(() => {
      if (chatBoxRef?.current?.lastElementChild) {
        chatBoxRef.current.lastElementChild.scrollIntoView({
          block: 'end',
        });
      }
    });

    resizeObserver.observe(divElement);
  }, [chatBoxRef]);

  return (
    <Container embed={embed}>
      {conversation.messages.length === 0 && isFetched && (
        <IntroMessage embed={embed} sendMessage={sendMessage} />
      )}
      <BoxWrapper conversation={conversation.messages} ref={chatBoxRef}>
        {conversation.messages.map((message, index) => {
          const isTyping =
            conversation.messages.length - 1 === index && botIsTyping;

          return (
            <Message
              key={index}
              message={message}
              setBotIsTyping={setBotIsTyping}
              botIsTyping={isTyping}
              embed={embed}
            />
          );
        })}
        {conversation.waitingBot && (
          <Message
            embed={embed}
            message={{ owner: BOT }}
            waitingBot={conversation.waitingBot}
            setBotIsTyping={setBotIsTyping}
            botIsTyping={botIsTyping}
          />
        )}
      </BoxWrapper>
    </Container>
  );
};

MessageList.propTypes = {
  waitingBot: PropTypes.object,
  conversation: PropTypes.object,
  setBotIsTyping: PropTypes.func,
  botIsTyping: PropTypes.bool,
  embed: PropTypes.bool,
  sendMessage: PropTypes.func,
  isFetched: PropTypes.bool,
};

const BoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 24px 0;
  ${props =>
    props.conversation.length === 0 &&
    css`
      margin: 0;
    `}
`;

const Container = styled.div`
  padding: 0px 24px;
  overflow: auto;
  display: block;
  height: ${props => (!props.embed ? 'auto' : '74vh')};
`;
